'use client';

import { Box, HStack, VStack, Skeleton } from '@chakra-ui/react';

export function StoriesModalSkeleton() {
  return (
    <Box gap={2} bg="background" p={4}>
      {/* Story Items Skeleton */}
      <VStack gap={4} align="stretch">
        {Array.from({ length: 4 }, (_, index) => (
          <Box
            key={`skeleton-${index}`}
            gap={3}
            rounded="2xl"
            bg="foreground/[0.03]"
            p={4}
          >
            {/* Story Content */}
            <VStack gap={3} align="stretch">
              {/* Top Row: Side/Leverage + PnL */}
              <HStack justify="space-between" align="center">
                {/* Side and Leverage Tags */}
                <HStack gap={2.5} align="center">
                  <HStack gap={1} align="center">
                    {/* Side Tag */}
                    <Skeleton h={6} w={12} rounded="md" />
                    {/* Leverage Tag */}
                    <Skeleton h={6} w={8} rounded="md" />
                  </HStack>
                </HStack>

                {/* PnL Display */}
                <HStack gap={1} align="center">
                  <Skeleton h={4} w={16} rounded="md" />
                  <Skeleton h={3} w={12} rounded="md" />
                </HStack>
              </HStack>

              {/* Timeline */}
              <HStack gap={2} align="center">
                {/* Timeline Icon */}
                <Skeleton h="3.5" w="3.5" rounded="md" />
                <Skeleton h={3} w={20} rounded="md" />
              </HStack>
            </VStack>

            {/* Story Title/Analysis */}
            <VStack gap={1} align="stretch" mt={3}>
              <Skeleton h={4} w="full" rounded="md" />
              <Skeleton h={4} w="3/4" rounded="md" />
            </VStack>
          </Box>
        ))}
      </VStack>
    </Box>
  );
}
